import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSplit: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="split"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C12.4142 2 12.75 2.33579 12.75 2.75V21.25C12.75 21.6642 12.4142 22 12 22C11.5858 22 11.25 21.6642 11.25 21.25V2.75C11.25 2.33579 11.5858 2 12 2ZM2 7.75C2 5.67893 3.67893 4 5.75 4H9V20H5.75C3.67893 20 2 18.3211 2 16.25V7.75ZM15 4H18.25C20.3211 4 22 5.67893 22 7.75V16.25C22 18.3211 20.3211 20 18.25 20H15V4Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSplit;
